import * as React from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxPositionerProps extends PartProps<React.ComponentProps<typeof Combobox.Positioner>> {
  className?: string
  anchor?: React.RefObject<HTMLElement | null>
}

function ComboboxPositioner({ className, children, anchor, ...props }: ComboboxPositionerProps) {
  return (
    <Combobox.Positioner
      className={twMerge('z-[100] outline-none', className)}
      sideOffset={4}
      anchor={anchor}
      {...props}
    >
      {children}
    </Combobox.Positioner>
  )
}

export { ComboboxPositioner }
